export const CLOCK_HOUR_WIDTH = 36;
export const TIME_DURATION_MASK = `HHh MMm`;
export const TIME_DURATION_24H_MASK = `HH:MM`;
export const TIME_DURATION_NUMBER_FORMAT = `00h 00m`;
export const TIME_DURATION_NUMBER_24H_FORMAT = `00:00`;
